import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {AddressAutocompleteComponent} from "../../../ui-components/address-autocomplete/address-autocomplete.component";
import {AppAlertService} from "../../services/app-alert/app-alert.service";
import {TranslateService} from "@ngx-translate/core";
import {AppMessageService} from "../../services/app-message/app-message.service";
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.component.html',
  styleUrl: './address-list.component.scss'
})
export class AddressListComponent implements  OnChanges {
  @ViewChild('addressComponent') addressComponent: AddressAutocompleteComponent;
  @Output() addressItemsChange = new EventEmitter<any[]>();
  @Input() addresses: any[] = [];
  @Input() titles: any[] = [];
  @Input() title:string | null=null;
  @Input() form:FormGroup;
  @Input() isSubmit:boolean=false;

  newAddressItem: boolean = false;
  newAddressData: any = {
    title: { label: '', value: null },
    city: '',
    district: '',
    formattedAddress: '',
    postalCode: '',
    street: '',
    addressDescription: '',
    latitude: null,
    longitude: null,
    isPriority: false,
  }
  addressItems: Array<any> = [];
  isEditing: boolean = false;
  selectedRow: any;
  editingIndex: number | null = null;
  activeTooltipIndex: number | null = null;
  tooltipPosition = { x: 0, y: 0 };

  newHeadItem() {
    this.cancel()
    this.newAddressItem = !this.newAddressItem;
    if(this.addressItems && this.addressItems.length > 0) {
      this.newAddressData = {
        title: { label: '', value: null },
        city: '',
        district: '',
        formattedAddress: '',
        postalCode: '',
        street: '',
        addressDescription: '',
        latitude: null,
        longitude: null,
        isPriority: false,
      }
    } else {
      this.newAddressData = {
        title: { label: '', value: null },
        city: '',
        district: '',
        formattedAddress: '',
        postalCode: '',
        street: '',
        addressDescription: '',
        latitude: null,
        longitude: null,
        isPriority: true,
      }
    }
  }

  constructor(private readonly appAlertService: AppAlertService,
              private readonly translate: TranslateService,
              private readonly messageService: AppMessageService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["addresses"]?.currentValue) {
      const array=changes["addresses"].currentValue?.length > 0 ? changes["addresses"].currentValue : []
      this.addressItems =array.map((data: any) => {
        return {
          ...data,
          title:data?.title?.valueObject ? {
            label:data?.title?.valueObject?.name?.value,
            value:data?.title?.valueObject?.id?.value
          } : {
            label: this.titles.find(t => t.value===data.title)?.label,
            value: data.title
          },
        }
      })
    }
  }

  openAddressModal(item?: any) {
    this.addressComponent.openDialog(item);
  }

  cancel() {
    if (this.editingIndex !== null) {
      this.addressItems[this.editingIndex].isEditing = false;
    }
    for(const item of this.addressItems){
      item.isEditing = false
    }
    this.isEditing = false;
    this.selectedRow = null;
    this.editingIndex = null;
  }

  addAddress(): void {
    const newAddress = {...this.newAddressData};

    if(this.addressItems.length === 0) {
      newAddress.isPriority = true;
      this.completeAdd(newAddress);
      this.newAddressItem=false;
      return;
    }

    if(newAddress.isPriority) {
      this.appAlertService.sweetConfirm({
        header: this.translate.instant('shared-components.address-priority'),
        message: this.translate.instant('shared-components.priority-change-confirm'),
        showCloseButton: true, 
        accept: () => {
          for(const item of this.addressItems){
            item.isPriority = false
          }
          this.completeAdd(newAddress);
        },
        reject: () => {}
      })
    } else {
      this.completeAdd(newAddress)
    }


  }

  completeAdd(newAddress: any){
    this.addressItems.push(newAddress);

    this.newAddressData = {
      title: { label: '', value: null },
      city: '',
      district: '',
      formattedAddress: '',
      postalCode: '',
      street: '',
      addressDescription: '',
      latitude: null,
      longitude: null,
      isPriority: false,
    }
    const addressDataToEmit = this.addressItems.map(address => {
      return {
        ...address,
        title: address?.title?.value
      };
    });
    this.addressItemsChange.emit(addressDataToEmit);
  }

  deleteItem(index: number): void {
    this.hideTooltip()
    this.addressItems.splice(index, 1);
    this.addressItemsChange.emit(this.addressItems);
  }

  edit(item: any, index: number) {
    this.newAddressItem = false
    for(const addressItem of this.addressItems){
      addressItem.isEditing = false;
    }
    this.addressItems[index].isEditing = true;
    this.selectedRow = { ...item };
    this.editingIndex = index;
    this.hideTooltip()

  }

  saveItem() {
    if (this.editingIndex !== null) {
      const priorityCount = this.addressItems.filter(item => item.isPriority).length;

      // ✅ Eğer priority false -> true'ya değişecekse sweetConfirm göster
      if (
        this.selectedRow.isPriority === true &&
        this.addressItems[this.editingIndex].isPriority === false
      ) {
        this.appAlertService.sweetConfirm({
          header: this.translate.instant('shared-components.address-priority'),
          message: this.translate.instant('shared-components.priority-change-confirm'),
          showCloseButton: true, 
          accept: () => {
            for (const [i, addressItem] of this.addressItems.entries()) {
              if (i !== this.editingIndex) {
                addressItem.isPriority = false;
              }
            }

            this.completeSave();
          },
          reject: () => {
            this.cancel();
          }
        });
        return; // ✅ SweetConfirm sonrası devam etmesini engelle
      }

      // Eğer priority kaldırılacaksa ve listede sadece 1 tane varsa uyarı göster
      if (
        this.selectedRow.isPriority === false &&
        this.addressItems[this.editingIndex].isPriority === true &&
        priorityCount === 1
      ) {
        this.messageService.infoToast(
          this.translate.instant('shared-components.priority-required'),
          this.translate.instant('shared-components.one-priority-address'),
        );
        return;
      }
    }


   if(this.editingIndex!==null){
    const priorityCount = this.addressItems.filter(item => item.isPriority).length;
     // Eğer seçilen satır priority ise ve birden fazla telefon varsa sweetConfirm göster
    if (this.selectedRow.isPriority && priorityCount ===1 && this.addressItems[this.editingIndex].isPriority === false) {
      this.appAlertService.sweetConfirm({
        header: this.translate.instant('shared-components.address-priority'),
        message: this.translate.instant('shared-components.priority-change-confirm'),
        showCloseButton: true, 
        accept: () => {
          for (const [i, addressItem] of this.addressItems.entries()) {
            if (i !== this.editingIndex) {
              addressItem.isPriority = false;
            }
          }

          this.completeSave();
        },
        reject: () => {
          this.cancel();
        }
      });
    } else {
      this.completeSave();
    }
   }
  }

  completeSave(){
    if (this.editingIndex !== null) {
      this.addressItems[this.editingIndex] = { ...this.selectedRow };
      this.addressItems[this.editingIndex].isEditing = false;
    }
    const addressDataToEmit = this.addressItems.map(address => {
      return {
        ...address,
        title: address?.title?.value,
      };
    });
    this.addressItemsChange.emit(addressDataToEmit);
    this.isEditing = false;
    this.selectedRow = null;
    this.editingIndex = null;
  }

  handleSetAddress(event: any): void {
    if (this.selectedRow) {
      this.selectedRow.formattedAddress = event.formattedAddress;
      this.selectedRow.city = event.city;
      this.selectedRow.district = event.district;
      this.selectedRow.latitude = event?.latitude?.toString();
      this.selectedRow.longitude = event?.longitude?.toString();
      this.selectedRow.postalCode = event.postalCode;
      this.selectedRow.street = event.street;
      this.selectedRow.addressDescription = event.addressDescription;
      this.selectedRow.country=event?.country;
    } else {
      this.newAddressData.formattedAddress = event.formattedAddress;
      this.newAddressData.city = event.city;
      this.newAddressData.district = event.district;
      this.newAddressData.latitude = event?.latitude?.toString();
      this.newAddressData.longitude = event?.longitude?.toString();
      this.newAddressData.postalCode = event.postalCode;
      this.newAddressData.street = event.street;
      this.newAddressData.addressDescription = event.addressDescription;
      this.newAddressData.country=event?.country;
    }
  }

  showTooltip(index: number, event: MouseEvent) {
    this.activeTooltipIndex = index;
    this.tooltipPosition = { x: event.clientX + 10, y: event.clientY + 10 }; // Tooltip'in fare pozisyonuna göre konumlandırılması
  }

  hideTooltip() {
    this.activeTooltipIndex = null;
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

}
